import styled from 'styled-components';

export const TileContentContainer = styled.div`
  width: 100%;
  padding: 40px 20px 0 40px;
  margin: auto auto;
  box-shadow: 0px 0px 10px rgba(0,0,0,0.06);
  border-radius: 5px;
`;

export const ErrorTitleContainer = styled(TileContentContainer)`
  padding: 40px 20px 40px 40px;
`;
